import { TranslatedCalling, Result } from './common';

export const defaultRenderer = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.default.call-created" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.default.call-in-progress" />,
  result: ({ toolCall }: any) => (
    <div className="relative">
      <Result toolCall={toolCall} />
    </div>
  ),
};
